<template>
  <div id="app">
    <div
      id="main-wrapper"
      data-theme="light"
      data-layout="vertical"
      data-navbarbg="skin6"
      data-sidebartype="full"
      data-sidebar-position="fixed"
      data-header-position="fixed"
      data-boxed-layout="full"
    >
      <TheNavbar />
      <TheSidebar />
      <div class="page-wrapper text-left">
        <router-view />
        <TheFooter />
      </div>
    </div>
  </div>
</template>

<style scoped>
/*@import '../assets/libs/bootstrap/dist/css/bootstrap.min.css';
@import '../assets/css/style.min.css';
@import '../assets/extra-libs/c3/c3.min.css';
@import '../assets/extra-libs/jvector/jquery-jvectormap-2.0.2.css';*/
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

<script>
import '../staticFiles';
import TheSidebar from './TheSidebar';
import TheNavbar from './TheNavbar';
import TheFooter from './TheFooter';

export default {
  name: 'TheContainer',
  components: {
    TheSidebar,
    TheNavbar,
    TheFooter,
  },
  created() {},
};
</script>
